import cryptoJs from "crypto-js";
import Utf8 from "crypto-js/enc-utf8";

import {hostnameBanList} from "../constants/hostnameBanList";

const key = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);
const iv = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);
const isEncrypted = !hostnameBanList.includes(window.location.hostname);

export const getRequest = (fullUrl, customHeader, token = localStorage.getItem("token")) => {
  let headers;

  if (token) {
    headers = {
      "Content-Type": isEncrypted ? "text/html" : "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": isEncrypted ? "text/html" : "application/json",
    };
  }

  if (customHeader && typeof customHeader === "object") {
    headers = {...headers, ...customHeader};
  }

  return fetch(fullUrl, {
    credentials: "same-origin",
    method: "GET",
    headers: new Headers(headers),
  })
    .then(response => {
      if (isEncrypted) {
        return response.text().then(data => {
          const {data: dataResponse} = JSON.parse(data);

          const dataDecrypted = cryptoJs.AES.decrypt(dataResponse, key, {
            iv,
          }).toString(Utf8);

          const json = JSON.parse(dataDecrypted);

          if (!response.ok) {
            return Promise.reject(json);
          }

          return Promise.resolve(json);
        });
      }

      return response.json().then(data => {
        if (!response.ok) {
          return Promise.reject(data);
        }

        return Promise.resolve(data);
      });
    })
    .catch(error => Promise.reject(error || new Error("Something when wrong")));
};
